module.exports = {

    type: {
        MIN:                    'min',
        MAX:                    'max',
        MEDIAN:                 'median',
        SUM:                    'sum',
        AVERAGE:                'average',
        RANGE:                  'range',
        CHECKED_TOTAL:          'checkedTotal',
        // CHECKED_NOT_CHECKED:    'checkedNotChecked',
    },

    name: {
        'min':                  'Minimum',
        'max':                  'Maximum',
        'median':               'Median',
        'sum':                  'Sum',
        'average':              'Average',
        'range':                'Range',
        'checkedTotal':         'Checked',
        'checkedNotChecked':    'Checked/Not checked'
    },

    label: {
        'min':                  'Min',
        'max':                  'Max',
        'median':               'Med',
        'sum':                  'Sum',
        'average':              'Avg',
        'range':                'Rng',
        'checkedTotal':         '',
        'checkedNotChecked':    ''
    },

    icon: {
        'min':                  'ii5-lightning',
        'max':                  'ii5-lightning',
        'median':               'ii5-lightning',
        'sum':                  'i5-summary-symbol',
        'average':              'ii5-lightning',
        'range':                ' i5-calendar',
        'checkedTotal':         'ii5-lightning',
        'checkedNotChecked':    'ii5-lightning',
    }
};